import React from 'react';
import { EnvelopeIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';

const EmailVerificationPending = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Icon */}
        <div className="text-center mb-8">
          <div className="inline-block p-4 bg-blue-100 rounded-full mb-4">
            <EnvelopeIcon className="h-16 w-16 text-blue-600 animate-pulse" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Email Adresinizi Doğrulayın
          </h1>
          <p className="text-gray-600">
            Hesabınız onaylandı! 🎉
          </p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
          {/* User Info */}
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-1">Hoş geldin,</p>
            <p className="text-xl font-bold text-gray-900">{user?.name}</p>
            <p className="text-sm text-gray-500 flex items-center mt-1">
              <EnvelopeIcon className="h-4 w-4 mr-1" />
              {user?.email}
            </p>
          </div>

          {/* Status */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <EnvelopeIcon className="h-5 w-5 text-blue-600 mr-3 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-blue-900 mb-1">
                  Email Doğrulama Gerekli
                </h3>
                <p className="text-sm text-blue-800">
                  Hesabınız admin tarafından onaylandı! Son adım olarak email adresinizi doğrulamanız gerekiyor.
                </p>
              </div>
            </div>
          </div>

          {/* Info */}
          <div className="space-y-3 mb-6">
            <div className="flex items-start text-sm">
              <span className="inline-block w-2 h-2 bg-gray-400 rounded-full mr-3 mt-1.5 flex-shrink-0"></span>
              <p className="text-gray-600">
                Email adresinize <strong className="text-gray-900">doğrulama linki</strong> gönderildi
              </p>
            </div>
            <div className="flex items-start text-sm">
              <span className="inline-block w-2 h-2 bg-gray-400 rounded-full mr-3 mt-1.5 flex-shrink-0"></span>
              <p className="text-gray-600">
                Linke tıklayarak hesabınızı <strong className="text-gray-900">aktifleştirebilirsiniz</strong>
              </p>
            </div>
            <div className="flex items-start text-sm">
              <span className="inline-block w-2 h-2 bg-gray-400 rounded-full mr-3 mt-1.5 flex-shrink-0"></span>
              <p className="text-gray-600">
                Email gelmediyse <strong className="text-gray-900">spam klasörünü</strong> kontrol edin
              </p>
            </div>
            <div className="flex items-start text-sm">
              <span className="inline-block w-2 h-2 bg-gray-400 rounded-full mr-3 mt-1.5 flex-shrink-0"></span>
              <p className="text-gray-600">
                Doğrulama linki <strong className="text-gray-900">24 saat</strong> geçerlidir
              </p>
            </div>
          </div>

          {/* Logout Button */}
          <button
            onClick={logout}
            className="w-full flex items-center justify-center px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition font-medium"
          >
            <ArrowRightOnRectangleIcon className="h-5 w-5 mr-2" />
            Çıkış Yap
          </button>
        </div>

        {/* Footer */}
        <div className="text-center mt-6">
          <p className="text-sm text-gray-500">
            Sorularınız için:{' '}
            <a href="mailto:destek@denemekoc.com" className="text-primary-600 hover:text-primary-700 font-medium">
              destek@denemekoc.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationPending;
